import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper';
import type {
  Account,
  AccountMutationData,
  AccountVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<AccountVariables, AccountMutationData>) {
  const { variables } = params;

  const {
    locator,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid, aid } = descriptor;

  const search = {
    uid,
    cid,
    id: aid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Account${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}


function ccPayloadFactory(params: RequestFactoryContext<AccountVariables, AccountMutationData>) {
  const { data } = params;
  return data.Account ? data : { Account: data };
}

export const mutationRequestContract = createRequestContract<AccountVariables, AccountMutationData>({
  schema,
  dataPath: 'user:customer:account',
  verb: requestVerbs.PATCH,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,
  payloadFactoryFn: ccPayloadFactory,

  keySelector: variables => variables.locator.descriptor.aid,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const mutationResponseContract = createResponseContract<
  AccountVariables,
  AccountMutationData,
  Account,
  Account,
  Account
>({
  requestContract: mutationRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: account => account.id,
  processorFn: response => response,
});
